import axios from 'axios'
import qs from 'qs'
import ElementUI from 'element-ui';
import router from '@/router/index';
// 初始化默认post header
// console.log('域名：',window.location.host)
switch (window.location.host) {
	case '39.108.17.53':
		axios.defaults.baseURL = 'http://39.108.17.53/dicai/web'; // 配置axios请求的地址
		break;
	case 'shop.mydecolor.com':
		axios.defaults.baseURL = 'https://shop.mydecolor.com'; // 配置axios请求的地址
		break;
	default:
		axios.defaults.baseURL = 'http://39.108.17.53/dicai/web'; // 配置axios请求的地址
		//axios.defaults.baseURL = 'https://shop.mydecolor.com'; // 配置axios请求的地址

}

const $axios = axios.create({
	timeout: 5000,
	withCredentials: false, // 允许携带cookie
	// headers: {
	// 	'Content-Type': 'application/x-www-form-urlencoded',
	// }
});
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
	let token = localStorage.getItem('authorization') || ''; //自动给同一个vue项目的所有请求添加请求头
	if (token) {
		config.headers['Authorization'] = 'Bearer ' + token || '';
	}
  config.headers['Content-Type'] ='application/x-www-form-urlencoded';
	//在发送请求之前做某件事
	if (config.method === 'post') {
		config.data = qs.stringify(config.data);
    // console.log('11111',config.data)
	}
	return config;
}, (error) => {
	ElementUI.Message('请求超时')
	return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
	//对响应数据做些事
	if (res.data.code == 9000 || res.data.code == 9001) {
		// token 出错 重新登录状态
		router.push('login'); // 无效问题
		return;
	} else if (res.data.code == 9003 || res.data.message == 9004) {
		ElementUI.Message(res.data.message)
		return;
	}
	if (!res.data.success) {
		ElementUI.Message(res.data.message)
		return Promise.resolve(res);
	}
	return res;
}, (error) => {
	console.log('网络异常', error)
	ElementUI.Message(error)

	return Promise.reject(error);
});

//检查token是否过期
const isClientAccessTokenExpired = function(callback) {
	// 判断API访问令牌是否过期
	var time = Math.floor(Date.now() / 1000);
	var clientExpiresIn = parseInt(localStorage.getItem('CLIENT_EXPIRES'));
	if (clientExpiresIn > (time - 3600)) {
		// 未过期
		typeof callback === "function" ? callback() : false;
		return false;
	} else {
		// 已过期, 刷新访问令牌
		updateToken(callback);
		return true;
	}
}
export function updateToken(callback) {
	return new Promise((resolve, reject) => {
		axios.post('/dicai/web/pc/user/update-access-token')
			.then(res => {
				if (res.data.success) {
					typeof callback === "function" ? callback() : false;
					if (res.data.success) {
						localStorage.setItem('authorization', data.access_token);
						localStorage.setItem('CLIENT_EXPIRES', data.expires);
					}
				}
			}, err => {
				reject(err);
			})
			.catch((error) => {
				reject(error)
			})
	})
}
//不用判断token接口
export function PostRequest(url, params, ) {
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(response => {
				resolve(response);
			}, err => {
				reject(err);
			})
			.catch((error) => {
				reject(error)
			})

	})
}
export function GetRequest(url, params, ) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params
			})
			.then(response => {
				resolve(response)
			}, err => {
				reject(err)
			})
			.catch((error) => {
				console.log('网络异常', error)
				reject(error)
			})

	})
}
//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
	return new Promise((resolve, reject) => {
		const promise = function() {
			axios.post(url, params)
				.then(response => {
					resolve(response);
				}, err => {
					reject(err);
				})
				.catch((error) => {
					reject(error)
				})
		}
		isClientAccessTokenExpired(function() {
			promise();
		})
	})


}
////返回一个Promise(发送get请求)
export function fetchGet(url, params) {
	params = params || {};

	return new Promise((resolve, reject) => {
		const promise = function() {
			axios.get(url, {
					params: params
				})
				.then(response => {
					resolve(response)
				}, err => {
					reject(err)
				})
				.catch((error) => {
					console.log('网络异常', error)
					reject(error)
				})
		}
		isClientAccessTokenExpired(function() {
			promise();
		})
	})
}
export default {
	fetchPost,
	fetchGet,
	PostRequest,
	GetRequest,
}



// WEBPACK FOOTER //
// ./src/https.js